import { useLocation } from "react-router-dom";
import AnnouncementBar from "./AnnouncementBar";
import PromoBar from "./PromoBar";
import Header from "./Header";
import Footer from "./Footer";
import WelcomeOffer from "./WelcomeOffer";

export default function Layout({ children, promo = true, heavenly = false }) {
  const { pathname } = useLocation();
  // Keep the promo popup off the checkout/order screens so it can't cover actions.
  const hideOffer = pathname.startsWith("/checkout") || pathname.startsWith("/order");
  return (
    <div className={`${heavenly ? "page-heavenly heavenly-scope" : "page-cream"} min-h-screen flex flex-col`}>
      <AnnouncementBar />
      <Header />
      {promo && <PromoBar />}
      <main className="flex-1">{children}</main>
      <Footer />
      {!hideOffer && <WelcomeOffer />}
    </div>
  );
}
